import { BREAKPOINT_TO_IMAGE_WIDTH, IMAGE, RESPONSIVE_TYPE } from './BreakpointToSizes';
import { windowLogger } from '../../../../_lib/Logger/windowLogger';

/**
 * Returns the valid separator for the image source.
 * Depending on it containing a ? already it returns &.
 * if it doesn't, it returns a ?.
 * @param source
 * @return {string}
 */
export function getQuerySeparator(source) {
  if (source) {
    return source.includes('?') ? '&' : '?';
  }
  return null;
}

/**
 * Creates srcset="..." of possible images with widths.
 * @param imageSource source of the image, might already contain query param
 * @param maxWidth of the src, provided by backend. will constrain the srcset.
 * maxWidth correlates to minWidth in upload constraints.
 */
export function getImageSetsBySource(imageSource, maxWidth) {
  const availAbleWidths = Object.values(IMAGE).filter(imageWidth => imageWidth <= maxWidth);
  return availAbleWidths.map(width => `${imageSource}${getQuerySeparator(imageSource)}width=${width} ${width}w`).join();
}

/**
 * Create the <source sizes="".
 */
function getImageSizesByType(responsiveImageType, valueName) {
  const responsiveType = BREAKPOINT_TO_IMAGE_WIDTH.find(respType => respType.type === responsiveImageType);
  if (!responsiveType) {
    windowLogger.warn('could not get responsive images for ', responsiveImageType);
    return;
  }

  if (valueName && Array.isArray(responsiveType.values[valueName])) {
    return responsiveType.values[valueName].map(type => `(max-width: ${type[0]}px) ${type[1]}px`).join(', ');
  }

  if (Array.isArray(responsiveType.values)) {
    return responsiveType.values.map(type => `(max-width: ${type[0]}px) ${type[1]}px`).join(', ');
  }

  return undefined;
}

getImageSizesByType.displayName = 'getImageSizesByType';

export { getImageSizesByType, RESPONSIVE_TYPE };
